module.exports = __webpack_public_path__ + "img/3h.efc29250.png";